import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import RequireAuth from "@/components/RequireAuth";
import AppShell from "@/components/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import Community from "@/pages/Community";
import Directory from "@/pages/Directory";
import MemberProfile from "@/pages/MemberProfile";
import Festivals from "@/pages/Festivals";
import Productions from "@/pages/Productions";
import Jobs from "@/pages/Jobs";
import DealRoom from "@/pages/DealRoom";
import Orgs from "@/pages/Orgs";
import Settings from "@/pages/Settings";

import "@/App.css";

function Shell({ children }) {
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#12100F",
              color: "#F5F5F5",
              border: "1px solid rgba(255,255,255,0.08)",
              borderLeft: "3px solid hsl(var(--ff-accent))",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/app"
            element={<RequireAuth><Shell><Home /></Shell></RequireAuth>}
          />
          <Route path="/app/community" element={<RequireAuth><Shell><Community /></Shell></RequireAuth>} />
          <Route path="/app/directory" element={<RequireAuth><Shell><Directory /></Shell></RequireAuth>} />
          <Route path="/app/members/:id" element={<RequireAuth><Shell><MemberProfile /></Shell></RequireAuth>} />
          <Route path="/app/festivals" element={<RequireAuth><Shell><Festivals /></Shell></RequireAuth>} />
          <Route path="/app/productions" element={<RequireAuth><Shell><Productions /></Shell></RequireAuth>} />
          <Route path="/app/jobs" element={<RequireAuth><Shell><Jobs /></Shell></RequireAuth>} />
          <Route path="/app/deal-room" element={<RequireAuth><Shell><DealRoom /></Shell></RequireAuth>} />
          <Route path="/app/orgs" element={<RequireAuth><Shell><Orgs /></Shell></RequireAuth>} />
          <Route path="/app/settings" element={<RequireAuth><Shell><Settings /></Shell></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
